import { render } from "./RetributionConfigurationsInfoModal.vue?vue&type=template&id=353ce89c"
import script from "./RetributionConfigurationsInfoModal.vue?vue&type=script&lang=js"
export * from "./RetributionConfigurationsInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__